module.exports = __webpack_public_path__ + "img/weixiufuwu.231c7408.png";